<template>
  <a
    v-if="canDownloadOBL || canDownloadVerifyCopy || canDownloadWaybill"
    data-test="document-type-link"
    href="javascript:;"
    @click="downloadDocumentLink"
  >
    <mc-loading-indicator v-if="downloading.includes(shipmentNumber + documentType)" class="icon-align-left" />
    <span v-else class="icon-align-left"><mc-icon icon="tray-aritem-down" size="20" /></span>
    {{ $t("documents." + documentType) }}
  </a>

  <div v-else-if="noSignedBLAgreement" data-test="document-download-no-signed-bl" class="d-flex">
    <mc-tooltip tooltipClasses="tooltip--center">
      <mc-icon slot="trigger" icon="info-circle" />
      <span>
        {{ $t("documents.webBLerror") }}
      </span>
    </mc-tooltip>
    <span class="ml-1">{{ $t("documents." + documentType) }}</span>
  </div>

  <div
    v-else-if="notTransportDocumentReceiver"
    data-test="document-download-not-transport-document-receiver"
    class="d-flex"
  >
    <mc-tooltip tooltipClasses="tooltip--center"
      ><mc-icon slot="trigger" icon="info-circle" /> <span> {{ $t("documents.permissionsError") }} </span></mc-tooltip
    >
    <span class="ml-1">{{ $t("documents." + documentType) }}</span>
  </div>

  <div v-else class="d-flex">
    <mc-tooltip tooltipClasses="tooltip--center"
      ><mc-icon slot="trigger" icon="info-circle" /><span>
        {{ $t("documents.permissionsError") }}
      </span></mc-tooltip
    >
    <span class="ml-1">{{ $t("documents." + documentType) }}</span>
  </div>

  <div
    v-if="shipmentNumber === docDownloadFailed2xx || shipmentNumber === docDownloadFailed5xx"
    class="color-error mt-1 d-flex"
  >
    <span class="mr-1"
      ><mc-icon icon="info-circle" size="20" color="var(--mds_brand_appearance_error_default_text-color)"
    /></span>
    <span v-if="docDownloadFailed2xx" data-test="document-download-2xx-error">{{
      $t("download.downloadFailed4xx")
    }}</span>
    <span v-if="docDownloadFailed5xx" data-test="document-download-5xx-error">{{
      $t("download.downloadFailed5xx")
    }}</span>
  </div>
</template>

<script>
import { getCustomerCodeFromJwt } from "@maersk-global/shared-js";
import { mapState, mapActions } from "pinia";
import { documents } from "@/store/documents";

export default {
  name: "DocumentDownload",
  props: {
    documentType: {
      type: String,
      required: true
    },
    parties: {
      type: Array,
      required: true
    },
    shipmentNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      downloading: []
    };
  },
  computed: {
    ...mapState(documents, ["docDownloadFailed2xx", "docDownloadFailed5xx", "hasSignedBLAgreement"]),
    canDownloadVerifyCopy() {
      return this.documentType === "verifyCopy" && (this.isTransportDocumentReceiver || this.isOutwardForwarder);
    },
    canDownloadOBL() {
      return this.documentType === "billOfLading" && this.isTransportDocumentReceiver && this.hasSignedBLAgreement;
    },
    canDownloadWaybill() {
      return this.documentType === "waybill" && this.isTransportDocumentReceiver;
    },
    noSignedBLAgreement() {
      return this.documentType === "billOfLading" && this.isTransportDocumentReceiver && !this.hasSignedBLAgreement;
    },
    notTransportDocumentReceiver() {
      return (
        (this.documentType === "billOfLading" && !this.isTransportDocumentReceiver) ||
        (this.documentType === "waybill" && !this.isTransportDocumentReceiver) ||
        (this.documentType === "verifyCopy" && !this.isTransportDocumentReceiver)
      );
    },
    isTransportDocumentReceiver() {
      const tpDocReceiver = this.parties?.find((item) => item.maerskRoleCode === "22");
      return tpDocReceiver?.id === getCustomerCodeFromJwt();
    },
    isOutwardForwarder() {
      const outwardForwarder = this.parties?.find((item) => item.maerskRoleCode === "15");
      return outwardForwarder && outwardForwarder.id === getCustomerCodeFromJwt();
    }
  },
  methods: {
    ...mapActions(documents, ["downloadDocument"]),
    async downloadDocumentLink() {
      if (this.downloading.includes(this.shipmentNumber + this.documentType)) {
        return;
      }
      this.downloading.push(this.shipmentNumber + this.documentType);
      await this.downloadDocument(this.documentType, this.shipmentNumber, this.parties);
      this.downloading = this.downloading.filter((item) => item !== this.shipmentNumber + this.documentType);
    }
  }
};
</script>
